exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-tiles{display:none}.product-tiles .tile-clr-bg{padding-top:48%}.tile-default-coloring{background-color:#b5ab9e}.tile-default-coloring:hover,.tile-default-coloring:focus{opacity:.8}", ""]);

// exports
